import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import CommonCard from "../common/commonCard";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { GetIncidentActivityTypesService, PostIncidentActivitySrvice } from "../../Services/incidentService";
import { GetIncidentUserService } from "../../Services/incidentService";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { PatchIncidentActivityService } from "../../Services/incidentService";
import MessagePopUp from "../common/messagePopUp";
import { formatToSpanishTimeZone } from "../../utils/formatDate";
import { formatTimeToSpanishTimeZone } from "../../utils/formatDate";
import { getFileInformation } from "../../utils/base64Conver";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

const PopUpTimeLine = ({
  show,
  onHide,
  item,
  activityType,
  readOnly,
  create,
  user,
}) => {
  const [t] = useTranslation("incidents")
  const [fieldErrors, setFieldErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [data, setData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const [activityTypes, SetActivityTypes] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);


  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const handleAcceptClick = async () => {
    setLoading(true)
    const response = await PatchIncidentActivityService(
      "aceptar",
      item.incidentActivity,
      activityType
    );
    const dataIncident = await GetIncidentUserService(response.userKey, response.company);
    const data = dataIncident[0];
    setData(data);
    setShowPopup2(true);
    closePopUp();
    setLoading(false)

  };
  const handleDeclineClick = async () => {
    setLoadingDecline(true)

    const response = await PatchIncidentActivityService(
      "rechazar",
      item.incidentActivity,
      activityType
    );
    const dataIncident = await GetIncidentUserService(response.userKey, response.company);
    const data = dataIncident[0];
    setData(data);
    setShowPopup2(true);
    closePopUp();
    setLoadingDecline(false)

  };

  const closePopUp = () => {
    setFieldErrors({});
    setFormData({});
    setFile(null);

    onHide();
  };

  const removeFile = () => {
    setFile(null);
  };

  const handleButtonMessagePopUpClick = () => {
    setShowPopup(false);
    setShowModal(true);

    if (location.pathname.includes("/check-incident/")) {
      navigate(`/check-incident/${data.incident}`, { state: { data } });
    } else {
      navigate(`/incident/${data.incident}`, { state: { data } });
    }
  };
  const handleButtonMessagePopUp2Click = () => {
    setShowPopup2(false);
    setShowModal2(true);

    if (location.pathname.includes("/check-incident/")) {
      navigate(`/check-incident/${data.incident}`, { state: { data } });
    } else {
      navigate(`/incident/${data.incident}`, { state: { data } });
    }
  };

  const handleFileInput = async (e) => {
    const fileData = e.target.files[0];

    if (!fileData) return; // Si no hay archivo, salir de la función

    const maxSize = 2 * 1024 * 1024; // 2 MB
    const valid_mimetypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',      // .xlsx
      'application/x-rar-compressed',
      'application/zip',
      'video/x-matroska',
      'video/mp4',
      'audio/mpeg'
    ];

    if (fileData.size > maxSize) {
      setFileError(`${t("histoyTable.fileSizeError")}`);
      setFile(null);
      return;
    }

    if (!valid_mimetypes.includes(fileData.type)) {
      setFileError(
        `${t("histoyTable.fileTypeError")} .zip, .rar, .doc, .xls, .pdf, .jpg, .png, .mp3, .mkv, .mp4`
      );
      setFile(null);
      return;
    }

    const fileConvert = await getFileInformation(fileData);

    setFile(fileConvert);
    setFileError(null);
  };

  const validateField = (field, value) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "description":
        if (value === "" || value === undefined) {
          isError = true;
          errorMessage = `${t("histoyTable.error")}`;
        } else if (value.length > 300) {
          isError = true;
          errorMessage = `${t("histoyTable.errorLength")}`;
        }
        break;

      case "date":
        isError = value === "" || value === undefined;
        errorMessage = isError
          ? `${t("histoyTable.dateError")}`
          : null;
        break;

      case "location":
        if (value === "" || value === undefined) {
          isError = true;
          errorMessage = `${t("histoyTable.error")}`;
        } else if (value.length > 300) {
          isError = true;
          errorMessage = `${t("histoyTable.errorLength")}`;
        }
        break;

      case "participants":
        if (value === "" || value === undefined) {
          isError = true;
          errorMessage = `${t("histoyTable.error")}`;
        } else if (value.length > 300) {
          isError = true;
          errorMessage = `${t("histoyTable.errorLength")}`;
        }
        break;

      default:
        break;
    }

    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError;
  };

  const handleFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [field]: value };
      validateField(field, value); // Validar el campo cuando se actualiza
      return updatedFormData;
    });
  };

  useEffect(() => {
    const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
    setIsFormValid(allFieldsValid);
  }, [fieldErrors]);

  useEffect(() => {
    const getActivityTypes = async () => {

      const ActivityTypesNames = await GetIncidentActivityTypesService();

      SetActivityTypes(ActivityTypesNames);
      setIsLoaded(true);
    };
    getActivityTypes();
  }, []);

  const checkFields = (data) => {
    return data.every((e) => validateField(e.field, e.value));
  };

  const handleSaveClick = async (dataForm) => {
    setLoading(true);
    if (checkFields(dataForm)) {
      formData.file = file;
      const post = {
        id,
        formData,
        activityType,
      };
      const response = await PostIncidentActivitySrvice(post);

      const dataIncident = await GetIncidentUserService(response.userKey, response.company);
      const data = dataIncident[0];
      setData(data);
      setLoading(false);
      setShowPopup(true);
      closePopUp();
    }
    setLoading(false);
  };
  const downloadDoc = (mimeType, fileData, fileName) => {
    const blob = b64toBlob(fileData, mimeType);
    const downloadLink = document.createElement("a");
    downloadLink.download = fileName;
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.click();
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const renderContent = () => {
    if (isLoaded) {
      switch (activityType) {
        // case "Propuesta de resolución":
        case activityTypes[10]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.resolutionProposal")}
                  icon={"FaRegQuestionCircle"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.resolutionProposal")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                    <FormCard
                      title={t("histoyTable.proposalSate")}
                      text={item.incidentActivityState}
                      type={"text"}
                      readOnly={true}
                    />
                    {/* <FormCard
                    title={"Respuesta de propuesta de resolución"}
                    text={item.description}
                    type={"textarea"}
                    readOnly={readOnly}
                  /> */}
                    {user &&
                      item.incidentActivityStateId !== "910a0738-261a-4d47-bc42-366108c6471f" &&
                      item.incidentActivityStateId !== "55ccb2f3-cb38-49ca-a220-08f9af419336" ? (
                      <div className="d-flex justify-content-around mt-4">
                        <Button
                          variant="secondary"
                          className="custom-button-secondary"
                          onClick={handleDeclineClick}
                          disabled={loadingDecline || loading}
                        >

                          {loadingDecline ?
                            <>
                              <Spinner animation="border" className="spinner" />
                              <span className="common-card-card-text">{t("histoyTable.declining")}</span>

                            </>
                            :
                            <>
                              {t("histoyTable.decline")}
                            </>
                          }
                        </Button>
                        <Button
                          variant="primary"
                          className="custom-button-primary"
                          onClick={handleAcceptClick}
                          disabled={loadingDecline || loading}
                        >

                          {loading ?
                            <>
                              <Spinner animation="border" className="spinner" />
                              <span className="common-card-card-text">{t("histoyTable.accepting")}</span>

                            </>
                            :
                            <>
                              {t("histoyTable.accept")}
                            </>
                          }
                        </Button>
                      </div>
                    ) : null}
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.resolutionProposal")}
                    icon={"FaRegQuestionCircle"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.resolutionProposal")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                        variant="success"
                        className="custom-shadow  modal-save-button"
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Petición de reunión":
        case activityTypes[9]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.meetingReq")}
                  icon={"FaRegQuestionCircle"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.meetingMessage")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.meetingReq")}
                    icon={"FaRegQuestionCircle"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.meetingMessage")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        variant="success"
                        className="custom-shadow  modal-save-button"
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case 'Cambio de responsable':
        case activityTypes[2]:
          return (
            <div>
              <CommonCard
                title={t("histoyTable.responsibleChange")}
                icon={"FaRetweet"}
              >
                <Button
                  variant="none"
                  className="modal-close-button"
                  onClick={closePopUp}
                >
                  <FaTimes className="mb-1" />
                </Button>
                <FormCard
                  title={t("histoyTable.responsibleChange")}
                  text={item.description}
                  type={"textarea"}
                  readOnly={readOnly}
                />
              </CommonCard>
            </div>
          );
        // case "Comentario del informante":
        case activityTypes[4]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.informantComment")}
                  icon={"FaComment"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.comment")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="text-center mt-4">
                      {item?.fileData ?
                        <Button
                          variant="secondary custom-shadow"
                          className=" custom-button-secondary m-auto "
                          disabled={!item?.fileData}
                          onClick={() =>
                            downloadDoc(
                              item.fileMimeType,
                              item.fileData,
                              item.fileName
                            )
                          }
                        >
                          {t("histoyTable.downloadDoc")}
                        </Button>
                        :
                        null
                      }
                    </div>
                  </>
                </CommonCard>
              ) : (
                <CommonCard
                  title={t("histoyTable.informantComment")}
                  icon={"FaComment"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.comment")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <Row>
                      <Col
                        md={12}
                        style={{ height: "100%" }}
                        className="d-flex flex-column align-items-center mt-5"
                      >
                        {file && (
                          <div className="mb-4 add-doc custom-shadow">
                            {" "}
                            {/* Añadido estilo para alinear a la izquierda */}
                            <span>{file.fileName}</span>
                            <FaTimes
                              className="add-doc-icon"
                              onClick={removeFile}
                            />
                          </div>
                        )}
                        {fileError && (
                          <span className="form-card-input-error-text m-auto text-center">
                            {fileError}
                          </span>
                        )}
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={handleFileInput}
                        />
                        <label htmlFor="fileInput">
                          <Button
                            variant="secondary"
                            className="custom-button-secondary"
                            as="span"
                          >
                            {t("histoyTable.addDoc")}
                          </Button>
                        </label>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        variant="success"
                        className="custom-shadow  modal-save-button"
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </>
                </CommonCard>
              )}
            </div>
          );
        // case "Comentario del responsable":
        case activityTypes[5]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.responsibleComment")}
                  icon={"FaComment"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.comment")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="text-center mt-4">
                      {item?.fileData ?
                        <Button
                          variant="secondary custom-shadow"
                          className=" custom-button-secondary m-auto "
                          disabled={!item?.fileData}
                          onClick={() =>
                            downloadDoc(
                              item.fileMimeType,
                              item.fileData,
                              item.fileName
                            )
                          }
                        >
                          {t("histoyTable.downloadDoc")}
                        </Button>
                        :
                        null
                      }
                    </div>
                  </>
                </CommonCard>
              ) : (
                <CommonCard
                  title={t("histoyTable.responsibleComment")}
                  icon={"FaComment"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.comment")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <Row>
                      <Col
                        md={12}
                        style={{ height: "100%" }}
                        className="d-flex flex-column align-items-center mt-5"
                      >
                        {file && (
                          <div className="mb-4 add-doc custom-shadow">
                            {" "}
                            {/* Añadido estilo para alinear a la izquierda */}
                            <span>{file.fileName}</span>
                            <FaTimes
                              className="add-doc-icon"
                              onClick={removeFile}
                            />
                          </div>
                        )}
                        {fileError && (
                          <span className="form-card-input-error-text m-auto text-center">
                            {fileError}
                          </span>
                        )}
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={handleFileInput}
                        />
                        <label htmlFor="fileInput">
                          <Button
                            variant="secondary"
                            className="custom-button-secondary"
                            as="span"
                          >
                            {t("histoyTable.addDoc")}
                          </Button>
                        </label>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        variant="success"
                        className="custom-shadow modal-save-button"
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </>
                </CommonCard>
              )}
            </div>
          );
        // case "Cancelación":
        case activityTypes[3]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.cancellation")}
                  icon={"FaBan"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.cancelationMessage")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.cancellation")}
                    icon={"FaBan"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.cancelationMessage")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                        variant="success"
                        className="custom-shadow  modal-save-button"
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Ampliación de plazo":
        case activityTypes[1]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.periodExtension")}
                  icon={"FaUserClock"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.periodExtensionMessage")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                    <FormCard
                      title={t("histoyTable.periodExtensionNewDate")}
                      text={item.title}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.periodExtension")}
                    icon={"FaUserClock"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.periodExtensionMessage")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                        variant="success"
                        className="custom-shadow  modal-save-button"
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Nota responsable":
        case activityTypes[8]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.responsibleNote")}
                  icon={"FaStickyNote"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.note")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                    <div className="text-center mt-4">
                      {item?.fileData ?
                        <Button
                          variant="secondary custom-shadow"
                          className=" custom-button-secondary m-auto "
                          disabled={!item?.fileData}
                          onClick={() =>
                            downloadDoc(
                              item.fileMimeType,
                              item.fileData,
                              item.fileName
                            )
                          }
                        >
                          {t("histoyTable.downloadDoc")}
                        </Button>
                        :
                        null
                      }
                    </div>
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.responsibleNote")}
                    icon={"FaStickyNote"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.note")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <Row>
                      <Col
                        md={12}
                        style={{ height: "100%" }}
                        className="d-flex flex-column align-items-center mt-5"
                      >
                        {file && (
                          <div className="mb-4 add-doc custom-shadow">
                            {" "}
                            {/* Añadido estilo para alinear a la izquierda */}
                            <span>{file.fileName}</span>
                            <FaTimes
                              className="add-doc-icon"
                              onClick={removeFile}
                            />
                          </div>
                        )}
                        {fileError && (
                          <span className="form-card-input-error-text m-auto text-center">
                            {fileError}
                          </span>
                        )}
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={handleFileInput}
                        />
                        <label htmlFor="fileInput">
                          <Button
                            variant="secondary"
                            className="custom-button-secondary"
                            as="span"
                          >
                            {t("histoyTable.addDoc")}
                          </Button>
                        </label>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                        variant="success"
                        className="custom-shadow  modal-save-button"
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Nota informante":
        case activityTypes[7]:
          return (
            <div>
              {!create ? (
                <CommonCard
                  title={t("histoyTable.informantNote")}
                  icon={"FaStickyNote"}
                >
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.note")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                    <div className="text-center mt-4">
                      {item?.fileData ?
                        <Button
                          variant="secondary custom-shadow"
                          className=" custom-button-secondary m-auto "
                          disabled={!item?.fileData}
                          onClick={() =>
                            downloadDoc(
                              item.fileMimeType,
                              item.fileData,
                              item.fileName
                            )
                          }
                        >
                          {t("histoyTable.downloadDoc")}
                        </Button>
                        :
                        null
                      }
                    </div>
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.informantNote")}
                    icon={"FaStickyNote"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.note")}
                      type={"textarea"}
                      readOnly={readOnly}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) =>
                        handleFieldChange("description", e.target.value)
                      }
                    />
                    <Row>
                      <Col
                        md={12}
                        style={{ height: "100%" }}
                        className="d-flex flex-column align-items-center mt-5"
                      >
                        {file && (
                          <div className="mb-4 add-doc custom-shadow">
                            {" "}
                            {/* Añadido estilo para alinear a la izquierda */}
                            <span>{file.fileName}</span>
                            <FaTimes
                              className="add-doc-icon"
                              onClick={removeFile}
                            />
                          </div>
                        )}
                        {fileError && (
                          <span className="form-card-input-error-text m-auto text-center">
                            {fileError}
                          </span>
                        )}
                        <input
                          type="file"
                          id="fileInput"
                          style={{ display: "none" }}
                          onChange={handleFileInput}
                        />
                        <label htmlFor="fileInput">
                          <Button
                            variant="secondary"
                            className="custom-button-secondary"
                            as="span"
                          >
                            {t("histoyTable.addDoc")}
                          </Button>
                        </label>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        onClick={() =>
                          handleSaveClick([
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                        variant="success"
                        className="custom-shadow  modal-save-button"
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        case "Admitido":
          return (
            <div>
              {!create ? (
                <CommonCard title={t("histoyTable.admitted")} icon={"FaCheck"}>
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={closePopUp}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <>
                    <FormCard
                      title={t("histoyTable.admittedMessage")}
                      text={item.description}
                      type={"textarea"}
                      readOnly={readOnly}
                    />
                  </>
                </CommonCard>
              ) : (
                <>
                  <CommonCard title={t("histoyTable.addmitted")} icon={"FaCheck"}>
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <FormCard
                      title={t("histoyTable.admittedMessage")}
                      text={item.description}
                      readOnly={readOnly}
                    />
                    <div className="d-flex justify-content-around mt-4">
                      <Button variant="success" className="custom-shadow  modal-save-button">
                        {t("histoyTable.save")}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Propuesta de reunión":
        case activityTypes[11]:
          return (
            <div>
              {" "}
              {!create ? (
                <>
                  <CommonCard
                    title={t("histoyTable.meetingProposal")}
                    icon={"FaCalendarDay"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <Row>
                      <Col md={6}>
                        <FormCard
                          title={t("histoyTable.meetingDate")}
                          text={formatToSpanishTimeZone(item.date, true)}
                          type={"text"}
                          readOnly={readOnly}
                        />
                      </Col>
                      <Col md={6}>
                        <FormCard
                          title={t("histoyTable.proposalSate")}
                          text={item.incidentActivityState}
                          type={"text"}
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormCard
                          title={t("histoyTable.meetingPlace")}
                          text={item.location}
                          type={"text"}
                          readOnly={readOnly}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormCard
                          title={t("histoyTable.meetingAnswer")}
                          text={item.description}
                          type={"textarea"}
                          readOnly={readOnly}
                        />
                      </Col>
                    </Row>
                    {user &&
                      item.incidentActivityState !== "910a0738-261a-4d47-bc42-366108c6471f" &&
                      item.incidentActivityState !== "55ccb2f3-cb38-49ca-a220-08f9af419336" ? (
                      <div className="d-flex justify-content-around mt-4">
                        <Button
                          variant="secondary"
                          className="custom-button-secondary"
                          onClick={handleDeclineClick}
                          disabled={loadingDecline || loading}
                        >

                          {loadingDecline ?
                            <>
                              <Spinner animation="border" className="spinner" />
                              <span className="common-card-card-text">{t("histoyTable.declining")}</span>

                            </>
                            :
                            <>
                              {t("histoyTable.decline")}
                            </>
                          }
                        </Button>
                        <Button
                          variant="primary"
                          className="custom-button-primary"
                          onClick={handleAcceptClick}
                          disabled={loadingDecline || loading}
                        >

                          {loading ?
                            <>
                              <Spinner animation="border" className="spinner" />
                              <span className="common-card-card-text">{t("histoyTable.accepting")}</span>

                            </>
                            :
                            <>
                              {t("histoyTable.accept")}
                            </>
                          }
                        </Button>
                      </div>
                    ) : null}
                  </CommonCard>
                </>
              ) : (
                <>
                  <CommonCard
                    title={t("histoyTable.meetingProposal")}
                    icon={"FaCalendarDay"}
                  >
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closePopUp}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                    <Row>
                      <Col md={12}>
                        <FormCard
                          title={t("histoyTable.meetingDate")}
                          type={"date"}
                          readOnly={readOnly}
                          limitToday
                          error={fieldErrors.date}
                          errorMessage={fieldErrors.dateMessage}
                          onChange={(e) =>
                            handleFieldChange("date", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormCard
                          title={t("histoyTable.meetingPlace")}
                          type={"text"}
                          readOnly={readOnly}
                          error={fieldErrors.location}
                          errorMessage={fieldErrors.locationMessage}
                          onChange={(e) =>
                            handleFieldChange("location", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormCard
                          title={t("histoyTable.observations")}
                          type={"text"}
                          readOnly={readOnly}
                          error={fieldErrors.description}
                          errorMessage={fieldErrors.descriptionMessage}
                          onChange={(e) =>
                            handleFieldChange("description", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-around mt-4">
                      <Button
                        variant="success"
                        className="custom-shadow  modal-save-button"
                        onClick={() =>
                          handleSaveClick([
                            { field: "date", value: formData.date },
                            { field: "location", value: formData.location },
                            { field: "description", value: formData.description },
                          ])
                        }
                        disabled={!isFormValid || loading}
                      >
                        {loading ? (
                          <div style={{ display: "flex", flexFlow: "row" }}>
                            <Spinner
                              animation="border"
                              className="spinner me-2"
                            />
                            <div>{t("histoyTable.generating")}</div>
                          </div>
                        ) : (
                          <>{t("histoyTable.save")}</>
                        )}
                      </Button>
                    </div>
                  </CommonCard>
                </>
              )}
            </div>
          );
        // case "Acta de reunión":
        case activityTypes[0]:
          return (
            <div>
              {!create ? (
                <>
                  <Row>
                    {/* Primer CommonCard */}
                    <Col md={12}>
                      <CommonCard title={t("histoyTable.meeting")} icon={"FaUsers"}>
                        <Button
                          variant="none"
                          className="modal-close-button"
                          onClick={closePopUp}
                        >
                          <FaTimes className="mb-1" />
                        </Button>
                        <Row>
                          <Col md={6}>
                            <FormCard
                              title={t("histoyTable.meetingJustDate")}
                              text={formatToSpanishTimeZone(item.date)}
                              type={"text"}
                              readOnly={readOnly}
                            />
                          </Col>
                          <Col md={6}>
                            <FormCard
                              title={t("histoyTable.meetingHour")}
                              text={formatTimeToSpanishTimeZone(item.date)}
                              type={"text"}
                              readOnly={readOnly}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.meetingPlace")}
                              text={item.location}
                              type={"text"}
                              readOnly={readOnly}
                            />
                          </Col>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.participants")}
                              text={item.participants}
                              type={"text"}
                              readOnly={readOnly}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.observations")}
                              text={item.description}
                              type={"textarea"}
                              readOnly={readOnly}
                            />
                          </Col>
                        </Row>
                        <div className="text-center mt-4">
                          {item?.fileData ?
                            <Button
                              variant="secondary custom-shadow"
                              className=" custom-button-secondary m-auto "
                              disabled={!item?.fileData}
                              onClick={() =>
                                downloadDoc(
                                  item.fileMimeType,
                                  item.fileData,
                                  item.fileName
                                )
                              }
                            >
                              {t("histoyTable.downloadDoc")}
                            </Button>
                            :
                            null
                          }
                        </div>
                      </CommonCard>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    {/* Primer CommonCard */}
                    <Col md={12}>
                      <CommonCard title={t("histoyTable.meetingRecord")} icon={"FaUsers"}>
                        <Button
                          variant="none"
                          className="modal-close-button"
                          onClick={closePopUp}
                        >
                          <FaTimes className="mb-1" />
                        </Button>
                        <Row>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.meetingJustDate")}
                              type={"date"}
                              readOnly={readOnly}
                              error={fieldErrors.date}
                              errorMessage={fieldErrors.dateMessage}
                              onChange={(e) =>
                                handleFieldChange("date", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.meetingPlace")}
                              type={"text"}
                              readOnly={readOnly}
                              error={fieldErrors.location}
                              errorMessage={fieldErrors.locationMessage}
                              onChange={(e) =>
                                handleFieldChange("location", e.target.value)
                              }
                            />
                          </Col>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.participants")}
                              type={"text"}
                              readOnly={readOnly}
                              error={fieldErrors.participants}
                              errorMessage={fieldErrors.participantsMessage}
                              onChange={(e) =>
                                handleFieldChange("participants", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            md={12}
                            style={{ height: "100%" }}
                            className="d-flex flex-column align-items-center mt-5"
                          >
                            {file && (
                              <div className="mb-4 add-doc custom-shadow">
                                {" "}
                                {/* Añadido estilo para alinear a la izquierda */}
                                <span>{file.fileName}</span>
                                <FaTimes
                                  className="add-doc-icon"
                                  onClick={removeFile}
                                />
                              </div>
                            )}
                            {fileError && (
                              <span className="form-card-input-error-text m-auto text-center">
                                {fileError}
                              </span>
                            )}
                            <input
                              type="file"
                              id="fileInput"
                              style={{ display: "none" }}
                              onChange={handleFileInput}
                            />
                            <label htmlFor="fileInput">
                              <Button
                                variant="secondary"
                                className="custom-button-secondary"
                                as="span"
                              >
                                {t("histoyTable.addDoc")}
                              </Button>
                            </label>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <FormCard
                              title={t("histoyTable.observations")}
                              type={"textarea"}
                              error={fieldErrors.description}
                              errorMessage={fieldErrors.descriptionMessage}
                              readOnly={readOnly}
                              onChange={(e) =>
                                handleFieldChange("description", e.target.value)
                              }
                            />
                            <p>{fieldErrors.description}</p>
                          </Col>
                        </Row>
                        <div className="d-flex justify-content-around mt-4">

                          <Button
                            variant="success"
                            className="custom-shadow  modal-save-button"
                            onClick={() =>
                              handleSaveClick([
                                { field: "date", value: formData.date },
                                { field: "location", value: formData.location },
                                {
                                  field: "participants",
                                  value: formData.participants,
                                },
                                {
                                  field: "description",
                                  value: formData.description,
                                },
                              ])
                            }
                            disabled={!isFormValid || loading}
                          >
                            {loading ? (
                              <div style={{ display: "flex", flexFlow: "row" }}>
                                <Spinner
                                  animation="border"
                                  className="spinner me-2"
                                />
                                <div>{t("histoyTable.generating")}</div>
                              </div>
                            ) : (
                              <>{t("histoyTable.save")}</>
                            )}
                          </Button>
                        </div>
                      </CommonCard>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          );
        // Agrega más casos según sea necesario
        default:
          return <div>{t("histoyTable.notActivity")}</div>;
      }
    };
  }
  return (
    <>
      <MessagePopUp
        show={showPopup}
        handleClose={() => setShowPopup(false)}
        title={t("histoyTablePopUp.successCreationTitle")}
        textBody={t("histoyTablePopUp.successCreationText")}
        buttonText={t("histoyTablePopUp.acceptButton")}
        onClickButton={handleButtonMessagePopUpClick}
      />
      <MessagePopUp
        show={showPopup2}
        handleClose={() => setShowPopup2(false)}
        title={t("histoyTablePopUp.successAnswerTitle")}
        textBody={t("histoyTablePopUp.successAnswerText")}
        buttonText={t("histoyTablePopUp.acceptButton")}
        onClickButton={handleButtonMessagePopUp2Click}
      />

      <Modal show={show} onHide={closePopUp} dialogClassName="modal-lg">
        <Modal.Body className="popup-activity-modal-body">
          {activityType
            ? renderContent() // renderiza el contenido si isLoaded es true
            : null // muestra un spinner mientras se cargan los datos
          }
          {/* {renderContent()} */}
          {/* Aquí se renderizará el contenido en función del tipo de actividad */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpTimeLine;
